import { PropertyDefinitionConfig } from '../types';

/** Pseudo-repository metadata for timeline UI labels. */
export const TIMELINE_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idTimelineRepository',
	singular: 'Timeline',
};
